/*
 * Seaszn: inline size quick-add for product cards.
 *
 * Renders as clickable size pills directly on the collection/product-grid
 * card (see snippets/card-product.liquid, quick_add == 'inline_sizes').
 * Clicking an available size adds that variant straight to the cart via the
 * storefront AJAX Cart API, with no page navigation and no modal — mirrors
 * the fetch/response handling in assets/product-form.js so it stays in sync
 * with the existing cart drawer / cart notification and header cart count.
 */
if (!customElements.get('quick-add-inline')) {
  customElements.define(
    'quick-add-inline',
    class QuickAddInline extends HTMLElement {
      constructor() {
        super();
        this.feedback = this.querySelector('.quick-add-inline__feedback');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('.quick-add-inline__size');
        if (!button || button.disabled || button.classList.contains('loading')) return;
        event.preventDefault();

        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        this.addToCart(variantId, button);
      }

      addToCart(variantId, button) {
        button.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(button);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            button.classList.remove('loading');

            if (response.status) {
              this.showFeedback(response.description || response.message || this.strings.error, true);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'quick-add-inline',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            button.classList.add('is-added');
            this.showFeedback(this.strings.added, false);

            if (this.cart) {
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'quick-add-inline',
                productVariantId: variantId,
                cartData: response,
              });
            }

            setTimeout(() => button.classList.remove('is-added'), 1800);
          })
          .catch((error) => {
            console.error(error);
            button.classList.remove('loading');
            this.showFeedback(this.strings.error, true);
          });
      }

      showFeedback(message, isError) {
        if (!this.feedback) return;
        this.feedback.textContent = message;
        this.feedback.hidden = false;
        this.feedback.classList.toggle('quick-add-inline__feedback--error', !!isError);
        clearTimeout(this._feedbackTimeout);
        this._feedbackTimeout = setTimeout(() => {
          this.feedback.hidden = true;
        }, 2600);
      }

      get strings() {
        return {
          added: this.getAttribute('data-added-text') || 'Added',
          error: this.getAttribute('data-error-text') || "Couldn't add to cart",
        };
      }
    }
  );
}
